'use strict';

let FISHFINGER = FISHFINGER || {};
let UTILS = UTILS || {};

FISHFINGER.nextProjectData = window.nextProjectData || {};
FISHFINGER.utils = UTILS || {};
FISHFINGER.utils.isMuted = false;
FISHFINGER.utils.counter = 0;
FISHFINGER.utils.isAnimInProgress = false;
FISHFINGER.utils.browserWidth = FISHFINGER.utils._screenSize().x;
FISHFINGER.position = $(window).scrollTop();

FISHFINGER.utils.navbarPosition = function() {
    let scroll;

    if ( document.querySelector('.l-navbar') && !document.querySelector('body').classList.contains('stop-scrolling') ) {
        scroll = window.scrollY || window.pageYOffset  || document.documentElement.scrollTop;

        if (scroll > 200) {
            document.querySelector('.l-navbar').classList.add('l-navbar--no-logo-title');
        } else {
            document.querySelector('.l-navbar').classList.remove('l-navbar--no-logo-title');
        }

        FISHFINGER.position = scroll;
    }
};

FISHFINGER.menu = {
    element: () => {
        return document.querySelector('.l-menu');
    },
    burgerElement: () => {
        return document.querySelector('.burger');
    },
    burger: function() {
        function makeNavBarWhite() {
            navbar.classList.remove('l-navbar--black');
        }

        function makeNavBarBlack() {
            navbar.classList.add('l-navbar--black');
        }

        if ( document.querySelector('.js-burger') ) {
            var burgerButton = document.querySelector('.js-burger'),
                menu = FISHFINGER.menu.element(),
                navbar = document.querySelector('.l-navbar'),
                curtain = document.querySelector('.burger--curtain'),
                navWrapper = document.querySelector('.burger--curtain'),
                body = document.querySelector('body');

            burgerButton.addEventListener("click", function( event ) {
                const submenuOpen = document.querySelector('.l-menu__list--submenu-open');
                const submenuItemsOpen = document.querySelector('.l-menu__item--submenu-open');

                event.preventDefault();

                if (burgerButton.classList.contains('open')) {
                	closeOverlay();

                    if (menu.classList.contains('open')) {
                        menu.classList.remove('open');
                        navbar.classList.remove('l-navbar--no-bg');
                    }

                    if (navbar.classList.contains('js-black-navbar')) {
                        makeNavBarBlack();
                    }

                    // if some submenu was opened and whole menu closed, we go back initial non-submenu state
                    setTimeout(function() {
                        if (submenuOpen) {
                            submenuOpen.classList.remove('l-menu__list--submenu-open');
                        }

                        if (submenuItemsOpen) {
                            submenuItemsOpen.classList.remove('l-menu__item--submenu-open');
                        }
                    }, 400);
                } else {
                    requestAnimationFrame(function() {
                        openOverlay(burgerButton, 'menu');
                    });

                    navbar.classList.add('l-navbar--no-bg');

                    setTimeout(() => {
                        menu.classList.add('open');
                    }, 400);

                    if (navbar.classList.contains('js-black-navbar')) {
                        makeNavBarWhite();
                    }
                }
            }, false);
        }
    },
    subMenu: function() {
        $('.js-open-submenu').on('click', function() {
            $(this).parent('.l-menu__item').addClass('l-menu__item--submenu-open');
            $('.l-menu__list').addClass('l-menu__list--submenu-open');
        });

        $('.js-close-submenu').on('click', function() {
            $(this).closest('.l-menu__item').removeClass('l-menu__item--submenu-open');
            $('.l-menu__list').removeClass('l-menu__list--submenu-open');
        });
    },
    colorChange: function() {
        const navbar = document.querySelector('.l-navbar'),
            navbarBlack = $('[data-navbar-black]').data('navbar-black'),
            navbarBgColor = $('[data-navbar-bg-color]').data('navbar-bg-color'),
            navbarFontColor = $('[data-navbar-font-color]').data('navbar-font-color');

        if (navbarBlack) {
            if (!navbar.classList.contains('l-navbar--black')) {
                navbar.classList.add('l-navbar--black');
                navbar.classList.add('js-black-navbar');
            }
        } else {
            if (navbar.classList.contains('l-navbar--black')) {
                navbar.classList.remove('l-navbar--black');
            }

            if (navbar.classList.contains('js-black-navbar')) {
                navbar.classList.remove('js-black-navbar');
            }
        }

        if (navbarFontColor) {
            navbar.classList.remove('l-navbar--font-white');
            navbar.classList.remove('l-navbar--font-black');
            navbar.classList.add(navbarFontColor);
        } else {
            navbar.classList.remove('l-navbar--font-white');
            navbar.classList.remove('l-navbar--font-black');
        }

        navbar.style.backgroundColor = navbarBgColor ? navbarBgColor : 'transparent';
    },
    logoLink: () => {
        $('.js-go-to-home-page').on('click', function() {
            const url = $(this).attr('href');

            if (FISHFINGER.menu.burgerElement().classList.contains('open')) {
                FISHFINGER.utils.loadPage( url );

                setTimeout(() => {
                    FISHFINGER.menu.burgerElement().click(); // close menu / overlay if opened, then go to desired page
                }, 300);

            } else {
                FISHFINGER.utils.loadPage( url );
            }

            return false;
        });
    },
    init: function() {
        this.burger();
        this.subMenu();
        this.logoLink();
    }
};

FISHFINGER.animation = {
    offsetScrolling: function() {
        if (!document.querySelector('.skrollr')) {
            return;
        }

        const s = skrollr.init();

        $(window).on('resize orientationchange', function() {
            try {
                s.refresh();
            } catch(e) {
                null;
            }

            setTimeout(function() {
                try {
                    s.refresh();
                } catch(e) {
                    null;
                }
            }, 100);
        });

        if (s.isMobile()) {
            s.destroy();
        }
    },
    headerIntro: function() {
        if (!document.querySelector('.l-header--intro')) {
            return;
        }
        const introWrapper = $('.l-header--intro__wrapper');
        const itemInterval = 3000;

        setTimeout(() => {
            introWrapper.addClass('fadeIn animated');
        }, 500);

        // loop through the intro texts
        const infiniteLoop = setInterval(() => {
            var current = $(".l-header--intro__text.l-header--intro__text--visible")

            var next = current.next('.l-header--intro__text');
            next = next.length ? next : null;

            if (next) {
                current.removeClass('l-header--intro__text--visible');
                next.addClass('l-header--intro__text--visible');
            }

        }, itemInterval);
    },
    init: function() {
        this.offsetScrolling();
        this.headerIntro();
    }
};

FISHFINGER.carousel = {
    carouselWithDotNavigation: function() {
        const owl = $('.owl-carousel--with-dots');
        const carouselSettings = {
            loop: false,
            margin: 0,
            nav: false,
            dotsContainer: '#js-dots-navigation',
            dots: true,
            autoplay: false,
            mouseDrag: false,
            responsive: {
                0: {
                    items: 1
                }
            }
        };

        if (owl.length) {
            owl.owlCarousel(carouselSettings);

            owl.find('.js-next-slide').click(function() {
                owl.trigger('next.owl.carousel');
            });

            // Go to the previous item
            owl.find('.js-prev-slide').click(function() {
                owl.trigger('prev.owl.carousel');
            });

        }
    },
    init: function() {
        this.carouselWithDotNavigation();
    }
};

FISHFINGER.fullPageScroll = function() {
    if (!$('#fullpage').length || $('#fullpage').length && FISHFINGER.utils.isTouch() && $('#fullpage').data('disable-on-mobile')) {

        if ( document.querySelector('.barba-container').getAttribute('data-namespace') === 'service' ) {
            $('header.js-fullpage-section').css('min-height', '100vh');
        }

        return;
    }

    $('#fullpage').fullpage({
        hybrid: true,
        fitToSection: false,
        fitToSectionDelay: 100,
        scrollingSpeed: 700,
        sectionSelector: '.js-fullpage-section',
        keyboardScrolling: false,
        scrollOverflow: FISHFINGER.utils.isTouch() ? true : false,
        scrollBar: false,
        autoScroll: false,
        afterLoad: function() {
            if (!FISHFINGER.utils.isTouch()) {
                $('.fp-auto-height').addClass('fp-normal-scroll');
            }
            // disable all events on links
            $('.fp-scroller a').off("click");
        }
    });

    // make a dynamic scroll when user scrolls up from normal scrolling section to the section which is not normally being scrolled
    const fullpageOneScrollSectionId = 'js-fullpage-one-scroll-section';
    const fullpageOneScrollSection = document.getElementById( fullpageOneScrollSectionId );

    if (fullpageOneScrollSection) {

        $.fn.fullpage.setScrollingSpeed(1300);

        const firstFullpageSection = new Waypoint({
            element: fullpageOneScrollSection,
            handler: function(direction) {
                const downArrowElement = $('#' + fullpageOneScrollSectionId).find('.arrow-down');

                $.fn.fullpage.setScrollingSpeed(1300);

                if (direction === 'up') {
                    $('html,body').animate({scrollTop: 0}, {"duration": 1150, "queue": false});

                    setTimeout(function() {
                        $.fn.fullpage.setAllowScrolling(true, 'down');
                        if (downArrowElement.length && downArrowElement.hasClass('arrow-down--hidden')) {
                            downArrowElement.removeClass('arrow-down--hidden');
                        }
                    }, 1500);
                }

                if (direction === 'down') {
                    if (downArrowElement.length && !downArrowElement.hasClass('arrow-down--hidden')) {
                        downArrowElement.addClass('arrow-down--hidden');
                    }
                }
            },
            offset: '-100%'
        });
    }
};

FISHFINGER.fullPageMoveSection = function(direction) {
    try {
        if ( direction === 'UP' ) {
            $.fn.fullpage.moveSectionUp();
        } else {
            $.fn.fullpage.moveSectionDown();
        }
    } catch(e) {
        null;
    };
};

FISHFINGER.fadeInOutWaypoint = () => {
    if (document.querySelector('.js-fade')) {
        let item = document.querySelector('.js-fade'),
            animTargets = item.querySelectorAll('.bg-media--image-fixed'),
            offset = 0,
            x = UTILS._screenSize().x;

        if ( x < 769) {
            offset = -100;
        } else {
            offset = -250;
        }

        [].forEach.call(animTargets, function(animTarget) {
            let section = new Waypoint({
                element: item,
                handler: function(direction) {

                    if( !document.documentElement.classList.contains('overflow-visible')) {
                        if (direction === 'down') {
                            animTarget.classList.remove('fadeIn');
                            animTarget.classList.remove('customZoomIn');
                            animTarget.classList.remove('customZoomIn--no-delay');
                            animTarget.classList.add('animated');
                            animTarget.classList.add('fadeOut');
                        } else {
                            animTarget.classList.remove('fadeOut');
                            animTarget.classList.remove('customZoomIn');
                            animTarget.classList.remove('customZoomIn--no-delay');
                            animTarget.classList.add('fadeIn');
                            animTarget.classList.add('animated');
                        }
                    }
                },
                offset: offset
            });
        });
    }
};


FISHFINGER.revealAnimation = (svgId) => {
    if (svgId) {
        $( svgId + ' .svg-mask').removeClass('svg-mask--hidden');
        $(svgId + ' .innerCircle').animate({svgR: 2000}, 2000);
    } else {
        $('.svg-mask').removeClass('svg-mask--hidden');
        $('.innerCircle').animate({svgR: 2000}, 2000);
    }
};

FISHFINGER.storyBoardPage = {
    currentScene: 0,
    sounds: [],
    scriptsTimeouts: {},
    nextSceneOverlay: $('.js-next-scene-overlay'),
    loaderProgressInfo: '#js-loader-progress-info',
    slidesCount: $('div[id^="scene-"]').length,
    sound: null,

    counter: () => {
        return $('.js-progress-counter');
    },
    pagepiling: function() {
        $('#js-storyboard-pagepiling').pagepiling({
            direction: 'vertical',
            verticalCentered: true,
            menu: '#js-storyboard-menu',
            scrollingSpeed: 900,
            sectionSelector: '.js-fullpage-section',
            keyboardScrolling: false,

            navigation: {
                'textColor': '#000',
                'bulletsColor': '#000',
                'position': 'left',
            },
        });
    },
    playScene: function(sceneId) {
        FISHFINGER.storyBoardPage.playSound(sceneId);
    },
    goToNextScene: function() {
        this.stopSound( this.currentScene );
        this.currentScene = this.currentScene+1;
        this.hideNextSceneOverlay();
        $.fn.pagepiling.moveSectionDown();
        this.playScene( this.currentScene );
    },
    replayScene: function() {
        this.stopSound( this.currentScene );
        this.skipCurrentScene();
        this.playScene( this.currentScene );
        this.hideNextSceneOverlay();
    },
    skipCurrentScene: function() {
        // check if the scene has been ever played - if so, clear the timeouts of scripts, stop sound.
        if (this.scriptsTimeouts[ 'scene-' + this.currentScene ]) {
            this.stopSound();
            const currentSceneTimeoutsLength = this.scriptsTimeouts[ 'scene-' + this.currentScene ].length;

            for (let i = 0; i <= currentSceneTimeoutsLength; i++) {
                clearTimeout( this.scriptsTimeouts[ 'scene-' + this.currentScene ][i] );
            }
        }
    },
    playSound: function(sceneId) {
        this.sounds[ sceneId ].play();
        this.currentScene = sceneId;

        return false;
    },
    playScript: function(sceneId) {
        const scriptsSlider = $('#scene-' + sceneId).find('.js-text-script');

        if (scriptsSlider.slick('slickCurrentSlide') !== 0) {
            scriptsSlider.slick('slickGoTo', 0);
        }

        const scripts = scriptsSlider.find('[data-script]');
        const scriptsLength = scripts.length;

        let timeForNextScriptPart = 0;
        this.scriptsTimeouts[ 'scene-' + sceneId ] = [];

        for (let i = 0; i < scriptsLength; i++) {
            let durationTime = $(scripts[i]).data('duration-ms');

            if (!durationTime) {
                if (timeForNextScriptPart > 0) {
                    this.scriptsTimeouts[ 'scene-' + sceneId ].push(
                        setTimeout(() => {
                            if ( this.slidesCount === (sceneId) + 1 ) {

                                $('.js-last-slide').removeClass('fullscreen--inactive');

                                var bottomBar = $('.js-last-slide-bottom');

                                FISHFINGER.storyBoardPage.endLastScene();

                                $('.js-pilingpage-slider-bottom').addClass('pilingpage-slider__bottom--hide');
                                bottomBar.removeClass('pilingpage-slider__bottom--hide');
                                bottomBar.css({'z-index': '2000'});
                                $('.js-skip-scene').css('display', 'none');
                            }

                            // to do: check if the scene is the last one. if so - show last scene overlay, if not - show next scene overlay
                            this.showNextSceneOverlay();
                        }, timeForNextScriptPart+100)
                    );
                }

                return;
            }

            timeForNextScriptPart = timeForNextScriptPart + durationTime;

            this.scriptsTimeouts[ 'scene-' + sceneId ].push(
                setTimeout(function() {
                    scriptsSlider.slick('slickNext');
                }, timeForNextScriptPart)
            );
        }
    },

    storyEnd: function (url = '/about') {
        Barba.Pjax.goTo( url );
    },

    playSlideshowInScene: function(sceneId) {
        const scene = $('#scene-' + sceneId);
        const slideshow = scene.find('.js-bg-media-slideshow.bg-media');
        const slideshowLength = slideshow.length;

        if (slideshow.length) {
            $(slideshow).not(':first').addClass('bg-media--hidden');
            $(slideshow).eq(0).removeClass('bg-media--hidden');

            let timeout = 0;

            for (let i = 0; i <= slideshowLength; i++) {
                let durationTime = $(slideshow[ i ]).data('duration-ms');
                timeout = timeout + durationTime;

                setTimeout(function() {
                    $(slideshow[ i ]).removeClass('bg-media--hidden');
                }, timeout);
            }
        }
    },
    playVideoInScene: function(sceneId) {
        const video = $('#scene-' + sceneId).find('video');
        let x = FISHFINGER.utils._screenSize().x;

        if (video.length) {
            video[0].play();
        }
    },

    pausePrevVideoInScene: function(sceneId) {
        if ( (sceneId*1) > 0) {
            sceneId = sceneId - 1;
            const video = $('#scene-' + sceneId).find('video');

            if (video.length) {
                video[0].pause();
            }
        }
    },

    stopSound: function() {
        this.sounds[ this.currentScene ].stop();
    },
    muteSound: function() {
        Howler.mute(true);
        FISHFINGER.utils.isMuted = true;
    },
    controls: function() {
        const slideUpControls = function() {
            $('.pilingpage-slider__bottom').addClass('pilingpage-slider__bottom--active');
        }

        $('.js-replay-scene').on('click', () => {
            this.replayScene();
        });

        $('.js-go-to-next-scene').on('click', () => {
            this.goToNextScene();
        });

        slideUpControls();
    },
    scriptSlider: function() {

        var afterChange = function(slider,i) {
            var slideHeight = jQuery(slider.$slides[i] ).outerHeight();
            jQuery(slider.$slider ).height( slideHeight);
        };

        const slickSettings = {
            dots: false,
            vertical: true,
            slidesToShow: 1,
            infinite: false,
            slidesToScroll: 1,
            draggable: false,
            pauseOnHover: false,
            accessibility: false,
            adaptiveHeight: false,
            arrows: false
        };

        $('.js-text-script').slick(slickSettings);

        $(window).on('resize orientationchange', function() {
            setTimeout(function() {
                $('.js-text-script').slick('unslick');
                $('.js-text-script').slick(slickSettings);
            }, 300);
        });
    },
    showNextSceneOverlay: function() {
        this.nextSceneOverlay.removeClass('fullscreen--inactive');
        $('#pp-nav').addClass('inactive');
    },
    hideNextSceneOverlay: function() {
        this.nextSceneOverlay.addClass('fullscreen--inactive');
        $('#pp-nav').removeClass('inactive');
    },
    startFirstScene: function() {
        this.controls();
        $('.barba-container .js-preloader').addClass('fullscreen--inactive');
        $('.pilingpage-slider').addClass('pilingpage-slider--active');
        $('#pp-nav').addClass('active');
        this.navigationEvents();
        this.playScene(0);
        Howler.volume(1);
    },
    replayStory: function() {
        $.fn.pagepiling.moveTo(1);
        FISHFINGER.storyBoardPage.startFirstScene();
        this.hideNextSceneOverlay();

        $('.js-last-slide').addClass('fullscreen--inactive');
        $('.js-pilingpage-slider-bottom').removeClass('pilingpage-slider__bottom--hide');
        var bottomBar = $('.js-last-slide-bottom');
        bottomBar.addClass('pilingpage-slider__bottom--hide');
        $('.js-skip-scene').css('display', 'block');
    },

    buttonSkipCurrentScene: function() {
        let sceneId = $('.js-fullpage-section.active').attr('id').replace('scene-','')*1;
        this.skipCurrentScene();

        if ( this.slidesCount === (sceneId) + 1 ) {
            var bottomBar = $('.js-last-slide-bottom');
            $('.js-last-slide').removeClass('fullscreen--inactive');

            FISHFINGER.storyBoardPage.endLastScene();

            $('.js-pilingpage-slider-bottom').addClass('pilingpage-slider__bottom--hide');
            bottomBar.removeClass('pilingpage-slider__bottom--hide');
            bottomBar.css({'z-index': '2000'});
            $('.js-skip-scene').css('display', 'none');
        } else {
            this.goToNextScene();
        }
    },

    buttonVolumeControl: function(obj) {
        if ($(obj).hasClass('control--active')) {
            Howler.volume(1);
            Howler.mute(false);
            FISHFINGER.utils.isMuted = false;
            $(obj).removeClass('control--active');

        } else {
            Howler.volume(0);
            Howler.mute(true);
            FISHFINGER.utils.isMuted = true;
            $(obj).addClass('control--active');
        }
    },

    endLastScene: function () {
        $('#pp-nav').removeClass('active');
    },

    transitions: function() {
        $('.js-transition-to-storyboard').off();

        $('.js-transition-to-storyboard').on('click', function() {
            if( document.body.classList.contains('.mobile-device') ) {
                return;
            }

            let storyboardPageUrl = $(this).attr('href'),
                mobileStoryboardPageUrl = $(this).attr('data-mobile-href'),
                maskId = $(this).attr('data-mask-id'),
                videoId = $(this).find('.js-canvid').attr('id'),
                wrapperClassName = $(this).attr('data-container-class'),
                x = FISHFINGER.utils._screenSize().x;

            FISHFINGER.utils.counter++;
            FISHFINGER.utils.isAnimInProgress = true;

            var maskSvg = $('#' + maskId).find('svg');

            FISHFINGER.utils.setOriginSizesOfSvgMaskImages();
            FISHFINGER.utils.svgCenter();

            maskSvg.attr('viewBox', '0 0 3000 3000');
            maskSvg.attr('width', '3000px');
            maskSvg.attr('height', '3000px');

            maskSvg.find('#mask1').attr('width', '3000');
            maskSvg.find('#mask1').attr('height', '3000');

            maskSvg.find('image').attr('width', '3000');
            maskSvg.find('image').attr('height', '3000');


            let allGifs = $('img[src$=".gif"]');
            allGifs.remove();

            let middleAnimationTimeout = 600,
                playVideoTimeout = 0,
                revealAnimationTimeout = 1400;

            if ( wrapperClassName === '.js-last-section' ) {
                $('.section:not(.js-last-section)').remove();
            }

            if( x < 768 ) {
                FISHFINGER.utils.loadPage(mobileStoryboardPageUrl);
            } else {
                FISHFINGER.utils.loadPage(storyboardPageUrl);
            }


            $(this).addClass('animated');
            $(wrapperClassName).addClass('bg-blue');

            $(wrapperClassName + ' .fishfinger-story-animation__poster').addClass('hidden');
            $(wrapperClassName + ' .section__left-column').addClass('section__left-column--slide-left');
            $(wrapperClassName + ' .section--double-bg__bg-to-the-right .section--double-bg__content-wrapper').addClass('fadeOut animated');
            $(wrapperClassName + ' .section--double-bg__bg-to-the-right .section--double-bg__content--no-max').addClass('fadeOut animated');
            $(wrapperClassName + ' .fishfinger-story-animation__bg').addClass('fadeOut animated');

            if ( wrapperClassName === '.js-last-section' ) {
                middleAnimationTimeout = middleAnimationTimeout + 500;
                playVideoTimeout = 100;
                revealAnimationTimeout = revealAnimationTimeout + 700;

                setTimeout(() => {
                    if (videoId) {
                        FISHFINGER.canVid.play(videoId);
                    }
                }, playVideoTimeout);
            } else {
                if (videoId) {
                    FISHFINGER.canVid.play(videoId);
                }
            }

            setTimeout(() => {
                $(wrapperClassName + ' .fishfinger-story-animation').addClass('fishfinger-story-animation--in-middle');
            }, middleAnimationTimeout);

            // setTimeout(() => {}, playVideoTimeout + 1000);

            let timer;

            var checker = function() {
                if (FISHFINGER.canVid.videos[ videoId ].getCurrentFrame() > 38) {
                    FISHFINGER.utils.isAnimInProgress = false;
                    FISHFINGER.revealAnimation('#' + maskId);
                    clearInterval(timer);
                }
            };

            timer = setInterval(checker, 200);

            return false;
        });
    },

    transitionMask: function() {
        $('.js-transition-to-storyboard-only-mask').on('click', function() {
            let storyboardPageUrl = $(this).attr('href'),
                maskId = $(this).attr('data-mask-id');
            FISHFINGER.utils.loadPage(storyboardPageUrl);
            setTimeout(() => {
                FISHFINGER.revealAnimation('#' + maskId);
            }, 200);
            return false;
        });
    },

    playPopupVideo: function(obj) {
        FISHFINGER.utils.loadVideos();

        var self = $(obj);
        $('#popup-with-video').addClass('open');
        $('.l-navbar').addClass('hidden');
        let videoObject = document.querySelector('#popup-with-video video');
        videoObject.play();

        self.find('.btn__inner').text('Replay');
        self.removeClass('btn--with-play-icon-left');
    },

    closePopupVideo: function() {
        $('#popup-with-video').removeClass('open');
        $('.l-navbar').removeClass('hidden');
        document.querySelector('#popup-with-video video').pause();
        $('#popup-with-video video').get(0).currentTime = 0;
    },

    buildTooltips: function() {
        let menuItems = document.querySelectorAll('#pp-nav ul li');

        [].forEach.call(menuItems, function(item, index) {
            item.querySelector('span').setAttribute('data-tooltip', window.sliderTitles[index]);
            item.querySelector('span').setAttribute('data-slide', index);
        });
    },
    navigationEvents: function() {
        $(document).on('click touchstart', '#pp-nav a', function(e){
            let self = this,
                selectedSlide = $(self).parent().index();

            $('#pp-nav a').removeClass('active');
            FISHFINGER.storyBoardPage.skipCurrentScene();
            FISHFINGER.storyBoardPage.hideNextSceneOverlay();
            FISHFINGER.storyBoardPage.playScene(selectedSlide);
            $(self).addClass('active');
        });
    },

    mobileTransitions: function() {
        $('.js-transition-to-storyboard').off();
        $('.js-transition-to-storyboard').on('click', function() {
            let storyboardPageUrl = $(this).attr('href'),
                mobileStoryboardPageUrl = $(this).attr('data-mobile-href'),
                x = FISHFINGER.utils._screenSize().x;

            if ( x < 768 ) {
                FISHFINGER.utils.loadPage(mobileStoryboardPageUrl);
            } else {
                FISHFINGER.utils.loadPage(storyboardPageUrl);
            }

            return false;
        });
    },

    init: function() {
        let x = FISHFINGER.utils._screenSize().x;

        if ( x > 767 ) {
            // init context variables
            FISHFINGER.storyBoardPage.currentScene = 0;
            FISHFINGER.storyBoardPage.sounds = [];
            FISHFINGER.storyBoardPage.scriptsTimeouts = {};
            FISHFINGER.storyBoardPage.nextSceneOverlay = $('.js-next-scene-overlay');
            FISHFINGER.storyBoardPage.loaderProgressInfo = '#js-loader-progress-info';
            FISHFINGER.storyBoardPage.slidesCount = $('div[id^="scene-"]').length;

            FISHFINGER.storyBoardPage.transitions();
            FISHFINGER.storyBoardPage.transitionMask();

            if (!$('#js-storyboard-pagepiling').length || !window.assets) {
                return;
            }

            let voiceAssetsDataAttr = $('#js-storyboard-pagepiling').attr('data-voice-list'),
                voiceAssetsArray,
                assetsDataAttr = $('#js-storyboard-pagepiling').attr('data-assets'),
                assetsArray;

            if (voiceAssetsDataAttr) {
                voiceAssetsArray = voiceAssetsDataAttr.replace(/'/g , "").split(',');
                window.voiceList = voiceAssetsArray;
            }

            if (assetsDataAttr) {
                assetsArray = assetsDataAttr.replace(/'/g , "").split(',');
                window.assets = assetsArray;
            }

            var loader = assetsLoader({
                assets: window.assets
            })
            .on('progress', (progress) => {
                let percentProgress = (progress * 100).toFixed();
                $("<style data-progress-info>" + FISHFINGER.storyBoardPage.loaderProgressInfo + ":after { width: " + percentProgress + "%; }</style>" ).appendTo("body");
                FISHFINGER.storyBoardPage.counter().html( percentProgress );

                if (percentProgress === '100') {
                    FISHFINGER.storyBoardPage.counter().parent().animate({opacity: 0}, 800);
                }
            })
            .on('complete', (assetsList) => {

                if (window.voiceList) {
                    for (let i = 0; i < window.voiceList.length; i++) {
                        let multipleSounds = Array.isArray(window.voiceList[i]);
                        let src = [ window.voiceList[i] ];

                        FISHFINGER.storyBoardPage.sounds.push( new Howl({
                            src: src,
                            onplay: function() {
                                FISHFINGER.storyBoardPage.playScript(i);
                                FISHFINGER.storyBoardPage.playSlideshowInScene(i);
                                FISHFINGER.storyBoardPage.playVideoInScene(i);

                                if ( i < FISHFINGER.storyBoardPage.slidesCount) {
                                    FISHFINGER.storyBoardPage.playVideoInScene(i + 1);
                                }

                                setTimeout(function() {
                                    FISHFINGER.storyBoardPage.pausePrevVideoInScene(i);
                                }, 500);
                            }
                        }) );
                    }
                }

                FISHFINGER.storyBoardPage.scriptSlider();
                FISHFINGER.storyBoardPage.pagepiling();
                FISHFINGER.turnOffScrolling();
                FISHFINGER.storyBoardPage.buildTooltips();
                FISHFINGER.utils.videoFit(true);

                setTimeout(() => {
                    $(FISHFINGER.storyBoardPage.loaderProgressInfo)
                        .removeClass('btn--loading-in-progress')
                        .addClass('btn--show-2nd-state')
                        .attr('disabled', false);

                    $("<style data-progress-info>" + FISHFINGER.storyBoardPage.loaderProgressInfo + ":after { width: 100%; }</style>" ).appendTo("body");

                    FISHFINGER.storyBoardPage.counter().html( 100 );
                    FISHFINGER.storyBoardPage.counter().parent().animate({opacity: 0}, 800);
                    FISHFINGER.storyBoardPage.playVideoInScene(0);

                }, 500);
            })
            .start();
        } else {
            FISHFINGER.storyBoardPage.mobileTransitions();
        }
    }
};

FISHFINGER.imageLoading = function() {
    const images = document.querySelectorAll('[data-load-img]');

    [].forEach.call(images, function(item, index) {
        $('<img class="animation-with-loading__loaded-image" src="' + $(item).data('load-img') + '" alt="" />')
            .on('load', function() {
                $(item).find('.animation-with-loading__loaded-image').addClass('active');
                $(item).find('.animation-with-loading__loader').remove();
            })
            .insertAfter($(item).find('.animation-with-loading__loader'));
    });
};

FISHFINGER.fullPagePillingScroll = function() {
    if (!$('#pagepiling').length) {
        $('.js-pagepiling').removeClass('js-pagepiling');
        return;
    } else {
        $('html').addClass('js-pagepiling');
    }

    $('#pagepiling').pagepiling({
        menu: null,
        direction: 'vertical',
        verticalCentered: true,
        scrollingSpeed: 900,
        keyboardScrolling: false,
        navigation: false,
        sectionSelector: '.js-fullpage-section',
        onLeave: function(index, nextIndex, direction) {
            if (direction === 'down') {
                let nextSlide = $('#pagepiling > *').eq(nextIndex);

                if (nextSlide.find('[data-run-gif]').length) {
                    let nextGif = nextSlide.find('[data-run-gif]');
                    $('<img data-gif-run="true" src="' + nextGif.data('run-gif') + '" alt="">').insertAfter(nextGif);
                }

                let prevSlide = $('#pagepiling > *').eq(index-2);

                if (prevSlide.find('[data-gif-run]').length ) {
                    setTimeout(function() {
                        prevSlide.find('[data-gif-run]').remove();
                    }, 500);

                }
            } else {
                let prevSlide = $('#pagepiling > *').eq(index-3);

                if (prevSlide.find('[data-run-gif]').length) {
                    let prevGif = prevSlide.find('[data-run-gif]');
                    $('<img data-gif-run="true" src="' + prevGif.data('run-gif') + '" alt="">').insertAfter(prevGif);
                }

                let nextSlide = $('#pagepiling > *').eq(index);
                if (nextSlide.find('[data-gif-run]').length) {
                    nextSlide.find('[data-gif-run]').remove();
                }
            }
        },
        afterRender: function(){
            setTimeout(() => {
                $('.is-initial').removeClass('is-initial');
            }, 200);

            let nextSlide = $('#pagepiling > *').eq(1);
            if (nextSlide.find('[data-run-gif]').length) {
                let nextGif = nextSlide.find('[data-run-gif]');
                $('<img data-gif-run="true" src="' + nextGif.data('run-gif') + '" alt="">').insertAfter(nextGif);
            }
        }
    });
};

FISHFINGER.canVid = {
    played: [],
    videos: {},
    play: (videoId) => {
        FISHFINGER.canVid.videos[ videoId ].resume();
    },
    pause:  (videoId) => {
        FISHFINGER.canVid.videos[ videoId ].pause();
    },
    init: () => {
        const canVideos = $('.js-canvid');
        const canVideosLength = canVideos.length;

        for (let i = canVideosLength - 1; i >= 0; i--) {
            let id = $(canVideos[i]).attr('id'),
                spriteImage = $(canVideos[i]).data('sprite-image'),
                canvasWidth = $(canVideos[i]).data('canvas-width'),
                canvasHeight = $(canVideos[i]).data('canvas-height'),
                frames = $(canVideos[i]).data('frames'),
                fps = $(canVideos[i]).data('fps') || 30,
                showFirstFrame = $(canVideos[i]).data('show-first-frame') || false;

            if  ( (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) || (!!window.MSInputMethodContext && !!document.documentMode) ){
                // Do Firefox-related activities
                let imgPathArray = spriteImage.split('.');
                spriteImage = imgPathArray[0] + '_firefox.' + imgPathArray[1];
            }

            let clipSettings = {
                src: spriteImage,
                frames: frames,
                cols: frames,
                fps: fps
            };

            if (showFirstFrame) {
                clipSettings.loops = 1;
            }

            FISHFINGER.canVid.videos[ id ] = canvid({
                selector : '#' + id,
                videos: {
                    clip1: clipSettings
                },
                width: canvasWidth,
                height: canvasHeight
                ,
                loaded: () => {
                    if (showFirstFrame) {
                        FISHFINGER.canVid.videos[ id ].play('clip1');
                        FISHFINGER.canVid.videos[ id ].pause();
                    } else {
                        FISHFINGER.canVid.videos[ id ].play('clip1');
                    }

                    $('#' + id).css({opacity: 1});
                }
            });
        }
    }
};


FISHFINGER.changeHeaderBannerVideo = function () {
    let homepageVideo = $('.js-header-video'),
        homePageBannerVideo = $('.js-header-video source'),
        x = UTILS._screenSize().x;

    if ( x <= 320) {
        homePageBannerVideo.attr('data-src', homepageVideo.attr('data-320'));
    } else if ( x > 320 && x <= 375 ) {
        homePageBannerVideo.attr('data-src',  homepageVideo.attr('data-375'));
    } else if ( x > 375 && x <= 450 ) {
        homePageBannerVideo.attr('data-src',  homepageVideo.attr('data-414'));
    } else if ( x > 451 && x <= 768 ) {
        homePageBannerVideo.attr('data-src',  homepageVideo.attr('data-768'));
    } else {
        homePageBannerVideo.attr('data-src',  homepageVideo.attr('data-desktop'));
    }

    homepageVideo.on('loadedmetadata', function() {
        if (window && (/MSIE|Trident/.test(navigator.userAgent)) && window.addEventListener) {
            // if ( !homepageVideo[0].hasAttribute('data-nominal-width') ) {
                homepageVideo.attr('data-nominal-width', homepageVideo[0].videoWidth);
                homepageVideo.attr('data-nominal-height', homepageVideo[0].videoHeight);
            // }

            homepageVideo.addClass('js-video-full');
            FISHFINGER.utils.videoFit(true);
        }
    });
};

FISHFINGER.work = () => {
    $('.tile[data-go-to-case-study]').on('click', function() {
        let tile = $(this),
            assetsToPreloadObject = tile.data('go-to-case-study'),
            readyAssetsListToPreload = [],
            loadNow = false,
            url = tile.attr('href');

        setTimeout(() => {
            loadNow = true;
        }, 1000);

        if (assetsToPreloadObject) {
            readyAssetsListToPreload = FISHFINGER.getAssetsToPreload(assetsToPreloadObject);
        }

        tile.addClass('tile--loading');

        if ( tile.parent().is('[class*="tile--column-"]') ) {
            tile.parent().css('z-index', 10);
        }

        if ( tile.parent().parent().is('[class*="tile--column-"]')  ) {
            tile.parent().parent().css('z-index', 10);
        }

        if (readyAssetsListToPreload.length > 0) {
            const loader = assetsLoader({
                assets: readyAssetsListToPreload
            })
            .on('complete', (assetsList) => {
                let timer = setInterval(() => {
                    if (loadNow) {
                        FISHFINGER.utils.loadPage( url );
                        clearInterval( timer );
                    }
                }, 100);
            })
            .start();

        } else {
            setTimeout(() => {
                FISHFINGER.utils.loadPage( url );
            }, 1000);
        }

        return false;
    });
};

FISHFINGER.nextProject = () => {

    $('.js-next-project-button').off();
    $('.js-next-project-button').remove();

    if ( $('.js-next-project-data').length ) {
        let $nextProjectData = $('.js-next-project-data');
        let newAnchor = document.createElement('A');

        newAnchor.setAttribute('href', $nextProjectData.data('href'));
        newAnchor.setAttribute('class', 'js-next-project-button btn btn--triangle-right no-barba');
        newAnchor.setAttribute('data-go-to-case-study', JSON.stringify($nextProjectData.data('go-to-case-study')) );
        newAnchor.setAttribute('data-src', $nextProjectData.data('src'));
        newAnchor.text = 'Next project';
        $( newAnchor ).insertAfter( '.l-navbar__spacer' );
    }

    $('.js-next-project-button').on('click', function() {
        let tile = $(this);
        let assetsToPreloadObject = tile.data('go-to-case-study');
        let readyAssetsListToPreload = [];
        let url = tile.attr('href');

        if (assetsToPreloadObject) {
            readyAssetsListToPreload = FISHFINGER.getAssetsToPreload(assetsToPreloadObject);
        }

        if (readyAssetsListToPreload.length > 0) {
            const loader = assetsLoader({
                assets: readyAssetsListToPreload
            })
            .on('complete', (assetsList) => {
                FISHFINGER.utils.loadPage( url );
            })
            .start();

        } else {
            FISHFINGER.utils.loadPage( url );
        }

        return false;
    });
};

FISHFINGER.getAssetsToPreload = function(customAssetsList) {
    if (!customAssetsList) {
        return [];
    }

    let customAssetsArray = [];
    let allAssetResolutions;
    let highestResolutionAsset = null;
    let highestResolution = 0;
    let increment = 0;

    for (let resolutionKey in customAssetsList) {
        if (customAssetsList.hasOwnProperty(resolutionKey)) {

            if (resolutionKey === 'always') {
                customAssetsArray = [...customAssetsList[ resolutionKey ]];
                continue;
            }

            // take first asset as default
            if (increment === 0) {
                highestResolutionAsset = customAssetsList[ resolutionKey ];
            }

            let resolution = parseInt(resolutionKey.substr(8));

            // override `highestResolutionAsset` with asset that should be displayed based on user's resolution
            if (resolution <= FISHFINGER.utils._screenSize().x && resolution >= highestResolution) {
                highestResolutionAsset = customAssetsList[ resolutionKey ];
                highestResolution = resolution;
            }
        }

        increment++;
    }

    if (highestResolutionAsset) {
        if ($.isArray(highestResolutionAsset)) {
            highestResolutionAsset.map(resolution => {
                customAssetsArray.push(resolution);
            });
        } else {
            customAssetsArray.push(highestResolutionAsset);
        }
    }

    return customAssetsArray;
};

FISHFINGER.assetsPreloadingBehindCurtain = ({initialLoad = false, defaultAssetsToPreload = null, assetsPreloadedCallback = null} = {}) => {
    if (window.location.href.indexOf('fishfinger-story') > -1 && assetsPreloadedCallback) {
        assetsPreloadedCallback();
        return;
    }

    if (!($('.fullscreen--preloader.js-preloader')).length) {
        return;
    }

    let assetsToPreload = null
    let customAssetsList = $('.js-custom-assets-list').length ? $('.js-custom-assets-list').data('custom-assets') : null;

    if (customAssetsList) {
        assetsToPreload = FISHFINGER.getAssetsToPreload(customAssetsList);
    }

    if (defaultAssetsToPreload) {
        assetsToPreload = assetsToPreload ? [...assetsToPreload, defaultAssetsToPreload] : defaultAssetsToPreload;
    }

    if (!assetsToPreload) {
        return;
    }

    const loader = assetsLoader({
        assets: assetsToPreload
    })
    .on('complete', (assetsList) => {
        if (assetsPreloadedCallback) {
            assetsPreloadedCallback();
        }

        let homepageVideo = $('.js-header-video'),
            x = UTILS._screenSize().x;

        if( homepageVideo.length > 0 ) {
            // canplaythrough
            homepageVideo.on('canplay', function() {
                setTimeout(() => {
                    homepageVideo[0].play();
                    $('.fullscreen.js-preloader').addClass('fullscreen--overlay-hidden');
                }, 600);
            });
        } else {
            $('.fullscreen.js-preloader').addClass('fullscreen--overlay-hidden');
        }

        if (initialLoad) {
            let customPreloadAssetList = [];
            let linkCustomPreloads = document.querySelectorAll('link[rel="custom-preload"]');

            [].forEach.call(linkCustomPreloads, asset => {
                customPreloadAssetList.push(asset.getAttribute('href'));
            });

            assetsLoader({assets: customPreloadAssetList}).start();
        }
    })
    .start();
};


FISHFINGER.utils.opacityScroll = function() {
    const fadeInBg = $('.fade-in-bg'),
        parallaxLayerHeight = $('.l-header__bottom-parallax-layer'),
        height = parallaxLayerHeight.outerHeight(),
        range = $('.l-header').outerHeight() * 0.25,
        offset = height / 2.5;

    if (!parallaxLayerHeight.length) {
        return;
    }

    $(window).on('scroll', function() {

        setTimeout(function() {
            let scrollTop = $(this).scrollTop(),
                calc = ((scrollTop - offset) / range);

            if ( !document.documentElement.classList.contains('overflow-visible') ) {
                fadeInBg.css({ 'opacity': calc });

                if (calc > '1') {
                    fadeInBg.css({ 'opacity': 1 });
                } else if ( calc < '0' ) {
                    fadeInBg.css({ 'opacity': 0 });
                }
            }
        }, 100);

    });
};

FISHFINGER.utils.isTouch = function() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
};

FISHFINGER.utils.isAndroid = function() {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");

    return isAndroid;
};

FISHFINGER.utils.isIE = function() {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
       // Edge (IE 12+) => return version number
       return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
};

FISHFINGER.utils.vimeoVideoPlaying = function() {
    $('.js-play-vimeo-video').on('click', function() {
        const videoComponent = $(this).parent('.video'),
            iframe = videoComponent.find('iframe'),
            player = new Vimeo.Player(iframe);

        player.play().then(function() {
            videoComponent.addClass('video--playing');
        });

        return false;
    });

    // Vimeo lazy loading with autoplay (playing in player)
    let lazyLoadedVimeoIframes = document.querySelectorAll('.js-vimeo-lazy-load');

    if (lazyLoadedVimeoIframes.length === 0) {
        return;
    }

    [].forEach.call(lazyLoadedVimeoIframes, vimeoIframe => {
        let vimeoAutoplaySection = new Waypoint({
            element: vimeoIframe,
            handler: function(direction) {
                if (direction === 'down') {
                    let videoUrl = vimeoIframe.dataset.src;

                    if (!videoUrl) {
                        return;
                    }

                    delete vimeoIframe.dataset.src;
                    vimeoIframe.src = videoUrl;

                    if (videoUrl.indexOf('vimeo.com') > -1) {
                        let player = new Vimeo.Player(vimeoIframe);
                        player.ready().then(() => {
                            player.setVolume(0);
                        });
                    }
                }
            },
            offset: '100%'
        });
    });

};

FISHFINGER.utils.loadPage = (url) => {
    Barba.Pjax.goTo( url );
};

FISHFINGER.setMinHeightOnFullscreen = function(element = 'body') {
    element.find('.section--fullscreen').css({
        'min-height': FISHFINGER.utils._screenSize().y + 'px'
    });
};

FISHFINGER.contactFormCallback = function() {
    const contactForm = $('#js-contact-form'),
        successNotification = $('#js-success-form-notification');

    contactForm.fadeOut();

    setTimeout(() => {
        successNotification.fadeIn();
    }, 400);

    setTimeout(() => {
        successNotification.addClass('notification--animate');
    }, 500);
};

FISHFINGER.stickyToTop = {
    socialMediaOnPost: function() {
        const wrapper = $('.js-sticky-social-media-container'),
            layerToBeSticky = $('.js-sticky-social-media-to-top'),
            elBody = document.body;

        if (!wrapper.length && !layerToBeSticky.length) {
            return;
        }

        function calculate() {
            let scrollTopPosition = $(window).scrollTop(),
                leftOffsset = wrapper.offset().left,
                wrapperBottom = wrapper.offset().top + wrapper.outerHeight(true) - 50;

            if (scrollTopPosition >= wrapperBottom) {
                layerToBeSticky.addClass('is-sticky');
                layerToBeSticky.css({left: leftOffsset + 'px'});

                if (scrollTopPosition > $('.post').height() - 35) {
                    layerToBeSticky.removeClass('is-sticky');
                }
            } else {
                if (layerToBeSticky.hasClass('is-sticky')) {
                    layerToBeSticky.removeClass('is-sticky');
                    layerToBeSticky.css({left: 0});
                }
            }
        }

        window.addEventListener('scroll', function() {
            calculate();
        });

        window.addEventListener('resize', function() {
            calculate();
        });
    },
    init: function() {
        this.socialMediaOnPost();
    }
};

FISHFINGER.spriteMapAnimations = function() {
    const animations = $('[data-sprite-map-animation-class]'),
        animationsLength = animations.length;

    for (var i = animationsLength - 1; i >= 0; i--) {
        const animation =  animations.eq(i),
            animationClass = animation.data('sprite-map-animation-class'),
            spacerImg = animation.data('sprite-map-spacer'),
            falback = animation.data('animation-gif-fallback');

        if (FISHFINGER.utils.isAndroid() || FISHFINGER.utils.isIE()) {
            animation.html('<img src="' + falback + '" alt="">');
        } else {
            animation.html('<div class="sprite-map-animation ' + animationClass + '"><img class="sprite-map-animation__spacer" src="' + spacerImg + '" alt=""></div>');
        }
    }
};

FISHFINGER.utils.hoverAnimation = function hoverAnimation() {
    $('.js-sprite-anim').mouseover(function(event) {
        let self = this,
            animDuration = self.getAttribute('data-anim-duration')*1;

        if ( !$(self).hasClass('animate') ) {
            $(self).addClass('animate');
            setTimeout(function() {
                $(self).removeClass('animate');
            }, animDuration);
        }
    });
};

FISHFINGER.buttons = (parent = 'body') => {
    if ( !isAppleDevice() ) {
        $(parent + ' .btn').wrapInner('<span class="btn__inner"></span>');
        $(parent + ' .btn--loading-in-progress .btn__inner').wrapInner('<span class="btn__inner-1st-state"></span>');
        $(parent + ' .btn--loading-in-progress .btn__inner').append('<span class="btn__inner-2nd-state">Continue</span>');
    }

    if ( $(parent + ' .btn--loading-in-progress .btn__inner').length === 0 ) {

        $(parent + ' .btn--loading-in-progress').wrapInner('<span class="btn__inner"></span>');
        $(parent + ' .btn--loading-in-progress .btn__inner').wrapInner('<span class="btn__inner-1st-state"></span>');
        $(parent + ' .btn--loading-in-progress .btn__inner').append('<span class="btn__inner-2nd-state">Continue</span>');
    }

    if ( isAppleDevice() && $('#js-contact-form').length > 0 ) {
        $('#js-contact-form .btn').wrapInner('<span class="btn__inner"></span>');
    }
};

FISHFINGER.turnOffScrolling = function turnOffScrolling() {
    document.body.classList.add('scroll-off');
    $.fn.pagepiling.setAllowScrolling(false);
};

FISHFINGER.turnOnScrolling = function turnOnScrolling() {
    document.body.classList.remove('scroll-off');
    $.fn.pagepiling.setAllowScrolling(true);
};

FISHFINGER.fingerOnWorkSection = {
    showFinger: function() {
        const firstBlock = $('.js-btn-work-section');

        function calc() {
            let scrollTopPosition = $(window).scrollTop();

            if (scrollTopPosition >= 100) {
                firstBlock.addClass('arrow-down--hidden');
            } else {
                firstBlock.removeClass('arrow-down--hidden');
            }
        }

        window.addEventListener('scroll', function() {
            calc();
        });

        window.addEventListener('resize', function() {
            calc();
        });
    },
    init: function() {
        this.showFinger();
    }
};

FISHFINGER.lazyLoadingOfImages = function() {
    $('.lazy').Lazy({
        scrollDirection: 'vertical',
        effect: 'fadeIn',
        visibleOnly: true,
        afterLoad: function(element) {
            $(element).find('.lazy__loader').fadeOut();
            $(element).removeClass('lazy');
        }
    });

    if ($('.lazy.tile').length) {
        $('.lazy.tile').append('<div class="lazy__loader loader loader--style1"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"> <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/> <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/> </path> </svg></div>');
    }
};

FISHFINGER.videoPreload = function videoPreload() {
    if ( document.querySelector('video[preload=none]') ) {
        let allVideos = document.querySelectorAll('video[preload=none]'),
            x = UTILS._screenSize().x;
    }
};

FISHFINGER.utils.infiniteCallback = function infiniteCallback() {
    FISHFINGER.work();
    FISHFINGER.lazyLoadingOfImages();
    FISHFINGER.utils._animationedSections();
};

function runWebsiteScripts(settings = {}) {
    $('.js-cs-header').addClass('js-fade');
    $('.js-cs-header .bg-media--image, .js-cs-header .js-header-anim').removeClass('bg-media').addClass('bg-media--image-fixed');

    if ( isMobileTablet() ) {
        document.body.classList.add('mobile-device');
    }

    FISHFINGER.menu.colorChange();
    FISHFINGER.imageLoading();

    FISHFINGER.utils.infiniteScroll(FISHFINGER.utils.infiniteCallback);

    if (!settings.initialRun) {
        circularModalEffect({triggerWithinBarbaContainer: true});
    }

    setTimeout(function() {
        FISHFINGER.utils.opacityScroll();
        FISHFINGER.animation.init();
        FISHFINGER.carousel.init();
    }, 500);

    FISHFINGER.utils.hashAnchorClick();
    FISHFINGER.utils._animationedSections();
    FISHFINGER.utils._openPopupOnClick();
    FISHFINGER.utils._magnific();
    // FISHFINGER.carousel.init();
    FISHFINGER.lazyLoadingOfImages();
    // FISHFINGER.utils.loadVideos();

    // if ( FISHFINGER.utils.browserWidth !==  FISHFINGER.utils._screenSize().x) {

        FISHFINGER.changeHeaderBannerVideo();
        // UTILS.loadVideos();

        // FISHFINGER.utils.browserWidth =  FISHFINGER.utils._screenSize().x;
    // }

    if (!settings.doNotLoadCanVideos) {
        FISHFINGER.canVid.init();
    }

    FISHFINGER.fingerOnWorkSection.init();
    FISHFINGER.stickyToTop.init();
    FISHFINGER.utils.vimeoVideoPlaying();
    FISHFINGER.work();

    if (settings.initialRun) {
        FISHFINGER.buttons();
    } else {
        FISHFINGER.buttons('.barba-container');
    }

    FISHFINGER.nextProject();

    FISHFINGER.fullPagePillingScroll();
    FISHFINGER.utils.setOriginSizesOfSvgMaskImages();
    FISHFINGER.utils.svgCenter();

    if (!$('[data-destroy-fullpage-when-modal-on]').length || settings.initialRun ) {
        FISHFINGER.fullPageScroll();
    }

    if ( FISHFINGER.utils.isTouch() ) {
        document.querySelector('body').classList.add('touch-device');
        $('.section--six-blocks').parent().addClass('active');
    }

    FISHFINGER.fadeInOutWaypoint();

    FISHFINGER.videoPreload();
    FISHFINGER.utils.videoFit(true);
    FISHFINGER.storyBoardPage.init();
    addTouchBtnClass();

    if( document.body.classList.contains('mobile-device') ) {
        // $('.js-transition-to-storyboard').removeClass('no-barba');
        // $('.js-transition-to-storyboard').off();
    }

    if ( document.querySelector('.barba-container').getAttribute('data-namespace') === 'homepage' ) {
        document.querySelector('.barba-container').classList.add('bg-orange');

        UTILS.loadVideos();

        // if( navigator.platform.indexOf('Linux') > -1 ) {
        //     // $('#playAnim').click();
        //     $('body').bind('click', function() {document.querySelector('.js-header-video').play();});
        // }

        setTimeout(function() {
            document.querySelector('.barba-container').classList.add('bg-orange');
        }, 200);
    } else {
        let homepageVideo = $('.js-header-video');
        if ( homepageVideo.length && !Barba.HistoryManager.prevStatus() ) {
            homepageVideo[0].load();
        }
    }

    // remove fullpage on services pages on mobile
    if ( document.querySelector('.barba-container').getAttribute('data-namespace') === 'service' && FISHFINGER.utils.isTouch()) {
        try {
            $.fn.fullpage.destroy('all');
        } catch(e) {
            null
        };
        setTimeout(function() {
            try {
                $.fn.fullpage.destroy('all');
            } catch(e) {
                null
            };
        }, 500);
    }

    objectFitImages('.bg-media--image-fixed img');
}


function isWindows() {
    return navigator.platform.indexOf('Win') > -1;
}

function isAppleDevice() {
    return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}

function iOSVersion() {
    if(window.MSStream){
      // There is some iOS in Windows Phone...
      // https://msdn.microsoft.com/en-us/library/hh869301(v=vs.85).aspx
      return false;
    }
    var match = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/),
        version;

    if (match !== undefined && match !== null) {
      version = [
        parseInt(match[1], 10),
        parseInt(match[2], 10),
        parseInt(match[3] || 0, 10)
      ];
      return parseFloat(version.join('.'));
    }

    return false;
}

function isMobileTablet() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

function getChromeVersion() {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./),
        chromeClassName = raw ? ('chrome-' + parseInt(raw[2], 10) ) : false;

    if (chromeClassName) {
        document.body.classList.add(chromeClassName);
        document.body.classList.add('chrome');
    }

    return raw ? parseInt(raw[2], 10) : false;
}

function addTouchBtnClass() {
    if ( isAppleDevice() ) {
        $('.btn').addClass('btn-touch');
        $('body').addClass('apple-touch');
    }
}

function initScripts() {
    getChromeVersion();
    $('.js-cs-header').addClass('js-fade');
    $('.js-cs-header .bg-media--image, .js-cs-header .js-header-anim').removeClass('bg-media').addClass('bg-media--image-fixed');

    Barba.Pjax.start();
    Barba.Pjax.getTransition();
    Barba.Prefetch.init();
    FISHFINGER.menu.init();
    FISHFINGER.utils.hoverAnimation();

    if ( isWindows() ) {
        document.body.classList.add('windows');
    }

    if ( iOSVersion() && iOSVersion()<10) {
        document.body.classList.add('mobile--ios-less-10');
    }

    if ( FISHFINGER.utils.isTouch() ) {
        document.querySelector('body').classList.add('touch-device');
        $('.section--six-blocks').parent().addClass('active');
    }

    if ( isMobileTablet() ) {
        document.body.classList.add('mobile-device');
    }

    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        document.body.classList.add('safari');
    }

    if( document.body.classList.contains('mobile-device') ) {
        // $('.js-transition-to-storyboard').removeClass('no-barba');
        // $('.js-transition-to-storyboard').off();
    }
}

function destroyScripts(oldContainer = null) {
    // destroy Fullpage.js
    if (
        oldContainer &&
        oldContainer.find('#fullpage').length &&
        (
            !oldContainer.find('#fullpage').data('disable-on-mobile') ||
            oldContainer.find('#fullpage').data('disable-on-mobile') && !FISHFINGER.utils.isTouch()
        )
    ) {

        try {
            $.fn.fullpage.destroy('all');
        } catch(e) {
            null;
        };
    }

    // destroy Pagepiling.js
    if (oldContainer && oldContainer.find('#js-storyboard-pagepiling').length) {
        $('#pp-nav').remove();
        $('#pp-nav a').off();
        $('[data-progress-info]').remove();
        FISHFINGER.storyBoardPage.skipCurrentScene();
        $('.js-pagepiling').removeClass('js-pagepiling');
    }

    // destroy Skrollr
    if (oldContainer && oldContainer.find('.skrollr')) {
        skrollr.init().destroy();
    }

    // Destroy all Waypoints
    Waypoint.destroyAll();

    // turn off event capture on next project button
    $('.js-next-project-button').off();
    $('.js-transition-to-storyboard').off();
    $('.js-next-project-button').remove();
}

function trackPageGTM() {
    if (window['dataLayer'] !== undefined) {
        let pagePath = window.location.pathname;

        window.dataLayer.push({
            'event': 'content-view',
            'content-name': pagePath
        });
    }
}

/*
 * -----------------------------------------------------------
 * // Dynamic loading via Barba.js and its settings start here
 *
*/

// Fade in/out transition
const FadeTransition = Barba.BaseTransition.extend({
    start: function() {
        Promise
            .all([this.fadeOut(), this.newContainerLoading])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
        const deferred = new jQuery.Deferred();
        let fadeOutTimeout = 200;
        let animatePromise = 400;

        if (document.querySelector('.l-menu').classList.contains('open')) {
            fadeOutTimeout = 0;
            animatePromise = 0;
        }

        destroyScripts( $(this.oldContainer) );

        setTimeout(function() {
            deferred.resolve();
        }, fadeOutTimeout);

        return deferred.promise().then(() => {
            return $(this.oldContainer).animate({ opacity: 0 }, animatePromise).promise();
        });
    },

    fadeIn: function() {
        $(window).scrollTop(0); // scroll to top here

        var _this = this;
        var $el = $(this.newContainer);
        let menuWasOpened = document.querySelector('.l-menu').classList.contains('open');

        $(this.oldContainer).hide();
        FISHFINGER.setMinHeightOnFullscreen($el);

        $el.css({
            visibility : 'visible',
            opacity : 0
        });

        $el.animate({ opacity: 1 }, menuWasOpened ? 0 : 200, function() {
            if (menuWasOpened) {
                document.querySelector('.js-burger').click();
            }

            _this.done();
        });
    },

    valid() {
        const prev = Barba.HistoryManager.prevStatus();
        const current = Barba.HistoryManager.currentStatus();
        return prev && prev.namespace !== 'work';
    }
});


// Custom transition to Work page
const ToWorkTransition = Barba.BaseTransition.extend({
    start: function() {
        Promise
            .all([this.fadeOut(), this.newContainerLoading])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
        const deferred = new jQuery.Deferred();
        deferred.resolve();

        let menuWasOpened = false;
        let fadeOutTimeout = 400;

        if (document.querySelector('.l-menu').classList.contains('open')) {

            setTimeout(function() {
                document.querySelector('.js-burger').click();
                menuWasOpened = true;
            }, fadeOutTimeout);
        }

        return deferred.promise();
    },

    fadeIn: function() {
        $(window).scrollTop(0); // scroll to top here

        var _this = this;
        var $el = $(this.newContainer);

        $(this.oldContainer).hide();

        destroyScripts( $(this.oldContainer) );

        $el.css({
            visibility : 'visible',
            opacity : 0
        });

        // show overlay until all assets are loaded
        $('.fullscreen.js-preloader').removeClass('fullscreen--overlay-hidden');

        _this.done();

        FISHFINGER.assetsPreloadingBehindCurtain();

        setTimeout(function() {
            $el.animate({ opacity: 1 }, 0);
        }, 500);

    },

    valid() {
        const current = Barba.HistoryManager.currentStatus();
        const prev = Barba.HistoryManager.prevStatus();

        return prev && (current.url.indexOf('/work') > 0) && (current.url.indexOf('/work/') === -1);
    }
});

// Custom transition to About page
const AboutTransition = Barba.BaseTransition.extend({
    start: function() {
        Promise
            .all([this.fadeOut(), this.newContainerLoading])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
        const deferred = new jQuery.Deferred();
        let menuWasOpened = false;
        let fadeOutTimeout = 600;

        if (document.querySelector('.l-menu').classList.contains('open')) {
            document.querySelector('.js-burger').click();
            menuWasOpened = true;
        }

        setTimeout(function() {
            deferred.resolve();
        }, fadeOutTimeout);

        return deferred.promise().then(() => {
            return $(this.oldContainer).animate({ opacity: 0 }, 400).promise();
        });
    },

    fadeIn: function() {
        $(window).scrollTop(0); // scroll to top here

        var _this = this;
        var $el = $(this.newContainer);

        $(this.oldContainer).hide();

        destroyScripts( $(this.oldContainer) );

        $el.css({
            visibility : 'visible',
            opacity : 0
        });

        _this.done();

        const fishfingerStoryAnimationChecker = setInterval(function() {
            if (FISHFINGER.canVid.videos['fishfinger-story']) {
                try {
                    if (FISHFINGER.canVid.videos['fishfinger-story'].getCurrentFrame() > 0) {
                        $el.animate({ opacity: 1 }, 0);
                        clearInterval( fishfingerStoryAnimationChecker );

                        setTimeout(function() {
                            $('.fullscreen.js-preloader').addClass('fullscreen--overlay-hidden');
                        }, 200);
                    }
                } catch(e) {
                    null;
                } finally {
                    $el.animate({ opacity: 1 }, 0);
                    clearInterval( fishfingerStoryAnimationChecker );

                    setTimeout(function() {
                        $('.fullscreen.js-preloader').addClass('fullscreen--overlay-hidden');
                    }, 200);
                }
            }
        }, 100);
    },

    valid() {
        const prev = Barba.HistoryManager.prevStatus();
        const current = Barba.HistoryManager.currentStatus();

        return current.url.indexOf('about') > 0;
    }
});

// Slide up transition
const AboutToStoryboard = Barba.BaseTransition.extend({
    start: function() {
        Promise
            .all([this.fadeOut(), this.newContainerLoading])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
        const deferred = new jQuery.Deferred();
        deferred.resolve();
        return deferred.promise();
    },

    fadeIn: function() {

        var _this = this;
        var $el = $(this.newContainer);

        // show overlay until all assets are loaded
        if( document.body.classList.contains('mobile-device') ) {
            $('body > .fullscreen.js-preloader').removeClass('fullscreen--overlay-hidden');
        }

        destroyScripts( $(this.oldContainer) );

        $el.addClass('is-initial');
        $el.css({
            visibility : 'visible',
            opacity : 0
        });

        if( document.body.classList.contains('mobile-device') ) {

            $el.animate({ opacity: 1 }, 500, function() {
                setTimeout(function() {
                    $el.removeClass('is-initial');
                    runWebsiteScripts();
                }, 510);

                setTimeout(function() {
                    _this.done();
                    $('body > .fullscreen.js-preloader').addClass('fullscreen--overlay-hidden');
                }, 520);
            });
        } else {

            let timer;

            let checkerAnim = function() {
                if (!FISHFINGER.utils.isAnimInProgress) {
                    setTimeout(function() {
                        $el.animate({ opacity: 1 }, 500, function() {
                            setTimeout(function() {
                                $el.removeClass('is-initial');
                                runWebsiteScripts();
                            }, 510);

                            setTimeout(function() {
                                _this.done();
                            }, 520);
                        });
                    }, 1200);
                    clearInterval(timer);
                }
            };

            timer = setInterval(checkerAnim, 200);
        }
    },

    valid() {
        const prev = Barba.HistoryManager.prevStatus();
        const current = Barba.HistoryManager.currentStatus();

        // return prev && prev.namespace === 'about' && current.url.indexOf('storyboard') > 0;
        return prev && prev.namespace === 'about' && current.url.indexOf('fishfinger-story') > 0;
    }
});





// Slide up transition
const StoryboardToAbout = Barba.BaseTransition.extend({
    start: function() {
        Promise
            .all([
                this.fadeOut(),
                this.newContainerLoading,
                $('.js-preloader').removeClass('fullscreen--inactive')
            ])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
        const deferred = new jQuery.Deferred();
        let menuWasOpened = false;
        let fadeOutTimeout = 600;

        if (document.querySelector('.l-menu').classList.contains('open')) {
            document.querySelector('.js-burger').click();
            menuWasOpened = true;
        }

        setTimeout(function() {
            deferred.resolve();
        }, fadeOutTimeout);

        return deferred.promise().then(() => {
            return $(this.oldContainer).animate({ opacity: 0 }, 200).promise();
        });
    },

    fadeIn: function() {
        var _this = this,
            $el = $(this.newContainer);

        destroyScripts( $(this.oldContainer) );

        $el.css({
            visibility : 'visible',
            opacity : 1
        });

        _this.done();

        const fishfingerStoryAnimationChecker = setInterval(function() {
            if (FISHFINGER.canVid.videos['fishfinger-story'] && FISHFINGER.canVid.videos['fishfinger-story'].getCurrentFrame() > 0) {
                $el.animate({ opacity: 1 }, 0);
                clearInterval( fishfingerStoryAnimationChecker );

                setTimeout(function() {
                    $('.fullscreen.js-preloader').addClass('fullscreen--overlay-hidden');
                }, 200);
            } else {
                $el.animate({ opacity: 1 }, 0);
                clearInterval( fishfingerStoryAnimationChecker );
                setTimeout(function() {
                    $('.fullscreen.js-preloader').addClass('fullscreen--overlay-hidden');
                }, 200);
            }
        }, 100);
    },

    valid() {
        const prev = Barba.HistoryManager.prevStatus();
        const current = Barba.HistoryManager.currentStatus();

        return prev && prev.namespace === 'storyboard' && current.url.indexOf('about') > 0;
    }
});






// Slide up transition
const SlideUpTransition = Barba.BaseTransition.extend({
    start: function() {
        Promise
            .all([this.fadeOut(), this.newContainerLoading])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
        const deferred = new jQuery.Deferred();
        deferred.resolve();
        return deferred.promise();
    },

    fadeIn: function() {

        var _this = this,
            $el = $(this.newContainer);

        let windowTop = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);

        $(this.oldContainer).css('position', 'fixed').css('width', '100%').css('top', ( windowTop * (-1) ) + 'px').css('transform', 'translateZ(0)');
        // $(this.oldContainer).css('position', 'fixed').css('width', '100%').css('top', ( $(window).scrollTop() * (-1) ) + 'px').css('transform', 'translateZ(0)');

        destroyScripts( $(this.oldContainer) );

        $el.addClass('barba-container--hidden-on-bottom');
        $el.css({
            visibility : 'visible',
            position: 'absolute',
            'z-index': 50,
            top: ( UTILS._screenSize().y + $(window).scrollTop()) + 'px',
            left: 0,
            width: '100%'
        });

        let headerVideo = $el.find('.bg-media--video video');

        if ( headerVideo.length ) {
            FISHFINGER.changeHeaderBannerVideo();
            UTILS.loadVideos();
            headerVideo[0].play();
        }

        FISHFINGER.setMinHeightOnFullscreen($el);

        $('html,body').animate({scrollTop: 0}, {"duration":1000, "queue": false});

        $el.animate({ top: 0 }, {"duration":1000, "queue": false}, function() {});

        setTimeout(function() {
            $(this.oldContainer).hide();
            $el.css({position: 'static'});

            $el.find('.js-cs-header').addClass('js-fade');
            $el.find('.js-cs-header .bg-media--image, .js-cs-header .js-header-anim').removeClass('bg-media').addClass('bg-media--image-fixed');

            _this.done();
        }, 1100);
    },

    valid() {
        const prev = Barba.HistoryManager.prevStatus();
        const current = Barba.HistoryManager.currentStatus();

        return (prev && current.url.indexOf('/work/') > 0) || (prev && current.url.indexOf('case-study') > 0);
    }
});

/* Barba JS configuration */
let transitionsCounter = 0;

Barba.Pjax.getTransition = function() {
    const prev = Barba.HistoryManager.prevStatus();

    if (prev && prev.namespace === 'storyboard') {

    }

    if (SlideUpTransition.valid()) {
        return SlideUpTransition;
    } else if (AboutToStoryboard.valid()) {
        return AboutToStoryboard;


    } else if (StoryboardToAbout.valid()) {
        return StoryboardToAbout;

    } else if (ToWorkTransition.valid()) {
        return ToWorkTransition;

    } else if (AboutTransition.valid()) {
        return AboutTransition;
    } else {
        return FadeTransition;
    }
};

Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container) {
    history.scrollRestoration = 'manual';
    trackPageGTM();

    var js = container.querySelector("script");

    if(js != null){
        eval(js.innerHTML);
    }

    if (oldStatus.url && currentStatus.namespace === 'about') {
        $('.fullscreen.js-preloader').removeClass('fullscreen--overlay-hidden');
        FISHFINGER.canVid.init();
    }
});

Barba.Dispatcher.on('transitionCompleted', function(currentStatus, oldStatus) {
    if (transitionsCounter === 0) {
        runWebsiteScripts({initialRun: true});
    } else {
        if (oldStatus) {
            if (oldStatus.url && currentStatus.namespace === 'about') {
                runWebsiteScripts({doNotLoadCanVideos: true});
            } else if (oldStatus.url && currentStatus.namespace !== 'storyboard') {
                runWebsiteScripts();
            }
        }
    }

    transitionsCounter++;
});

(() => {
    let defaultAssetsToPreload = [
        '/images/ajax-loader.gif',
    ];

    FISHFINGER.assetsPreloadingBehindCurtain({
        initialLoad: true,
        defaultAssetsToPreload,
        assetsPreloadedCallback: initScripts
    });
})();

window.onbeforeunload = function () {
    window.scrollTo(0, 0);
}

window.addEventListener('resize', function() {
    setTimeout(function(){
        Waypoint.refreshAll();
        FISHFINGER.utils.opacityScroll();
        FISHFINGER.utils.svgCenter();

        if ( FISHFINGER.utils.browserWidth !==  FISHFINGER.utils._screenSize().x) {
            FISHFINGER.changeHeaderBannerVideo();
            UTILS.loadVideos();
            FISHFINGER.utils.browserWidth =  FISHFINGER.utils._screenSize().x;
        }

        try {
            setTimeout(function() {
                try {
                    $.fn.fullpage.reBuild();
                } catch(e) {
                    null;
                };
            }, 200);
            $.fn.fullpage.reBuild();
        } catch(e) {
            null;
        };
        FISHFINGER.utils.videoFit(true);
    }, 80);
}, false);


window.addEventListener('scroll', function() {
    FISHFINGER.utils.navbarPosition();
}, false);


document.addEventListener("visibilitychange", function() {
    if ( isMobileTablet() ) {
        if ( document.querySelector('.barba-container').getAttribute('data-namespace') === 'storyboard' ) {
            if ( document.hidden === true ) {
                Howler.volume(0);
            } else {
                if ( FISHFINGER.utils.isMuted === false ) {
                    Howler.volume(1);
                }
            }
        }
    }
});
